import { useQuery } from '@tanstack/react-query';
import { get } from '../api/client.js';

export function useReport({ kind, from, to, user }) {
  const params = new URLSearchParams({ kind, from: String(from), to: String(to) });
  if (user) params.set('user', user);
  return useQuery({
    queryKey: ['admin', 'reports', kind, from, to, user || 'all'],
    queryFn: () => get(`/api/admin/reports?${params.toString()}`),
    enabled: !!from && !!to,
    staleTime: 30_000,
  });
}

export function csvHref({ kind, from, to, user }) {
  const params = new URLSearchParams({ kind, from: String(from), to: String(to), format: 'csv' });
  if (user) params.set('user', user);
  return `/api/admin/reports?${params.toString()}`;
}
